module.exports = __webpack_public_path__ + "images/9ccf0eeed7ba5626e52e345a1810edd8.svg";